"use client";

import { IdleLogoffMonitor } from "@/app/_components/idle-logoff/IdleLogoffMonitor";
import { SessionProvider } from "next-auth/react";

type Props = {
  children?: React.ReactNode;
};

const NextAuthProvider = ({ children }: Props) => {
  return (
    <SessionProvider>
      {children}
      <IdleLogoffMonitor />
    </SessionProvider>
  );
};

export default NextAuthProvider;
